// scripts/seedAdminRole.ts
import { NotFoundError } from '@/api/ApiClient';
import { RoleApi } from '@/api/RoleApi';
import { PRIVATE_ROUTE_CATALOG } from '@/security/routes.catalog';
import { ROLE_ACTION_CATALOG } from '@/security/actions.catalog';
import { getTenantId } from '@utils/Auth';


/**
 * Crea (o actualiza) un rol "Admin" para el tenant actual
 * @param roleId    string - ID lógico del rol (ej. "admin")
 * @param name      string - Nombre legible (ej. "Administrador")
 */
export async function seedAdminRole(roleId = 'admin', name = 'Administrador') {
    // Construir objeto con todas las rutas y acciones en true
    const rules: Record<string, boolean> = {};
    for (const route of PRIVATE_ROUTE_CATALOG) {
        rules[route.id] = true;
    }
    for (const action of ROLE_ACTION_CATALOG) {
        rules[action.id] = true;
    }
    const tenantID = await getTenantId()
    const adminRoleId = `${tenantID}-${roleId}`
    try {
        // Buscar si ya existe
        const existing = await RoleApi.get(adminRoleId)

        if (existing?.id) {
            console.log(`🔄 Actualizando rol existente (${existing.id})`);
            await RoleApi.update(existing.id, {
                name,
                rules: JSON.stringify(rules),
                version: (existing.version || 1) + 1,
            });
            console.log('✅ Rol Admin actualizado');
        } else {
            throw new NotFoundError(`No existe el rol admin`, "API_ERROR");
        }
    } catch (err) {
        if (err instanceof NotFoundError) {
            console.log('🆕 Creando rol Admin');
            await RoleApi.create({
                id: adminRoleId,
                name,
                description: 'Rol administrador con acceso total a todas las rutas',
                rules: JSON.stringify(rules),
                version: 1,
            });
            console.log('✅ Rol Admin creado');
        }
    }
}